import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TooltipPosition } from '../../directives/tooltip.directive';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TooltipComponent {
  position: string = TooltipPosition.DEFAULT;
  tooltip = '';
  left = 0;
  top = 0;
  visible = false;

  constructor() {}
}
